// extracted by mini-css-extract-plugin
export default {"infoCard":"InfoCard_infoCard__scoHv","header":"InfoCard_header__4Hho5","subInfo":"InfoCard_subInfo__9yWBb","subInfoText":"InfoCard_subInfoText__JEf0v"};